import { initAgentSession } from 'actions/agentSessions';
import LoadingIndicator from 'components/LoadingIndicator';
import Navbar from 'components/Navbar';
import { startCase } from 'lodash';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getConnectionStatus } from 'selectors/agentSessions';
import { getAssignmentsLoading } from 'selectors/assignments';
import getSocketState from 'selectors/socketState';
import { NAV_BAR_HEIGHT_REM } from 'utils/dimensions';
import AgentChat from './AgentChat';

type RouteParams = {
  investigationId: string;
  agentId: string;
};

const InvestigationAgentPage: React.FC = () => {
  const dispatch = useDispatch();
  const { investigationId, agentId } = useParams<RouteParams>();

  const loading = useSelector(getAssignmentsLoading);
  const socketState = useSelector(getSocketState);
  const status = useSelector(getConnectionStatus);

  useEffect(() => {
    if (socketState === 'connected') {
      dispatch(
        initAgentSession({
          agentSessionId: agentId,
          investigationId,
        })
      );
    }
  }, [dispatch, investigationId, agentId, socketState]);

  const warningBarOffset =
    document != null &&
    document.getElementById != null &&
    document.getElementById('customer-warning')?.offsetHeight;

  return (
    <div
      className="flex flex-col min-w-screen bg-white overflow-hidden"
      style={{
        height: `calc(100vh - ${warningBarOffset}px)`,
      }}
    >
      <Navbar />
      <div
        className="py-10 px-10 flex flex-col gap-10"
        style={{
          height: `calc(100vh - ${warningBarOffset}px - ${NAV_BAR_HEIGHT_REM}rem)`,
        }}
      >
        <header className="flex">
          <div className="w-full flex flex-row justify-between items-center">
            <div className="flex flex-row items-center">
              <h2 className="text-heading-1">Agent</h2>
              {loading && <LoadingIndicator className="ml-2" size="5" />}
            </div>

            <span className="text-body">
              {startCase(socketState)} - {startCase(status)}
            </span>
          </div>
        </header>
        <main className="h-full w-full flex overflow-hidden">
          <AgentChat />
        </main>
      </div>
    </div>
  );
};

export default InvestigationAgentPage;
